import { Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';

@Component({
    components: {
        Modal,
        Thumbnail
    }
})
export default class AboutUseModal extends Vue {

    @Prop() 
    isShowAboutUseModal!: boolean

    closeModal() {
        this.$emit('update:isShowAboutUseModal', false);
    }

    @Watch('isShowAboutUseModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }
}      